import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getUser, updateUser } from "services/users";
import { useToast } from "components/Toast";

const AdminUserEdit: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const [name, setName] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("user");
  const [password, setPassword] = useState("");

  useEffect(() => {
    const load = async () => {
      if (!id) return;
      const result: any = await getUser(Number(id));
      const u = result?.data ? result.data : result;
      setFirstname(u.firstname || "");
      setLastname(u.lastname || "");
      setEmail(u.email || "");
      setRole(u.role || "user");
    };
    load();
  }, [id]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!id) return;
    try {
      const payload: any = { firstname, lastname, email, role };
      if (password) payload.password = password;
      await updateUser(Number(id), payload);
      navigate("/admin/users");
      toast.showSuccess("User updated");
    } catch (err) {
      console.error(err);
      toast.showError("Failed to update user");
    }
  };

  return (
    <div className="p-4">
      <h2 className="mb-4 text-xl font-semibold">Edit User</h2>
      <form onSubmit={handleSubmit} className="max-w-md space-y-4">
        <div>
          <label className="block">Name</label>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="input"
          />
        </div>
        <div>
          <label className="block">Email</label>
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="input"
          />
        </div>
        <div>
          <label className="block">Role</label>
          <select
            value={role}
            onChange={(e) => setRole(e.target.value)}
            className="input"
          >
            <option value="user">User</option>
            <option value="admin">Admin</option>
          </select>
        </div>
        <div>
          <label className="block">New Password (leave blank to keep)</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="input"
          />
        </div>
        <div>
          <button className="btn btn-primary" type="submit">
            Save
          </button>
        </div>
      </form>
    </div>
  );
};

export default AdminUserEdit;
